/**
 * useCopilotChatContext - Hook to access the copilot chat context
 */

import { useContext } from 'react';
import { CopilotChatContext, CopilotChatContextType } from '../context/CopilotChatContext';

export default function useCopilotChatContext(): CopilotChatContextType {
  const context = useContext(CopilotChatContext);

  if (!context || Object.keys(context).length === 0) {
    throw new Error('useCopilotChatContext must be used within a CopilotChatProvider');
  }

  return context;
}
